import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { motion } from "framer-motion";
import {
  setVotingSys,
  setMultiplicadorSys,
  addIssuesSys,
} from "../features/metadata/MetadataLogic";

export default function Configuration() {
  // REDUX ----------------------------------------------------------
  // Para obtener y modificar la data del individuo en Redux
  const jsonMetadata = useSelector((state) => state.jsonMetadata.value);
  const dispatch = useDispatch();

  //UI
  const [selectVotingSystemVal, setSelectVotingSystemVal] = useState("");
  const [boolIssue, setBoolIssue] = useState(false);
  //Logic
  const [votingSystem, setVotingSystem] = useState([]);
  const [multiplicador, setMultiplicador] = useState(2);
  const [issues, setIssues] = useState("");

  let navigate = useNavigate();
  const routeChange = () => {
    if (!votingSystem == "" && !multiplicador == "" && !issues == "") {
      // Cambiar el fomato texto a arreglo del elemento para poder recorrerlo en lo sucesivo
      let issuesArr = issues.split(",");
      let newIssuesArr = [];
      issuesArr.forEach((element) => {
        newIssuesArr.push(element.trim());
      });
      dispatch(addIssuesSys({ issues: newIssuesArr }));
      dispatch(setVotingSys({ votingSystem }));
      dispatch(setMultiplicadorSys({ multiplicador }));

      let path = "../VotingRoom";
      navigate(path);
    } else {
      alert("You must fill in the fields");
    }
  };

  useEffect(() => {
    switch (selectVotingSystemVal) {
      case "pizza":
        setVotingSystem([0, 0.5, 1, 2, 3, 5, 8, 13, 20, 40, 100, "?", "🍕"]);
        break;
      case "cocktail":
        setVotingSystem([0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, "?", "🍹"]);
        break;
      default:
        setVotingSystem([0, 0.5, 1, 2, 3, 5, 8, 13, 20, 40, 100, "?", "🍕"]);
        break;
    }
  }, [selectVotingSystemVal]);

  return (
    <motion.div
      className="App-header"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 2 } }}
      exit={{ opacity: 0 }}
    >
      <p>Voting System Configuration</p>
      <div class="mb-3">
        {/* <label for="votingSystem" class="form-label">Voting System</label> */}
        <motion.select
          class="form-select form-select-sm"
          name="votingSystem"
          id="votingSystem"
          value={selectVotingSystemVal}
          aria-label="required"
          onChange={(event) => setSelectVotingSystemVal(event.target.value)}
          animate={{ boxShadow: "10px 10px 0 rgba(0, 0, 0, 0.2)" }}
        >
          <option value="pizza">
            Pizza [0, ½, 1, 2, 3, 5, 8, 13, 20, 40, 100, ?, 🍕]
          </option>

          <option value="cocktail">
            Cocktail [0, 1, 2, 3, 5, 8, 13, 21, 34, 55, 89, ?, 🍹]
          </option>
        </motion.select>
      </div>
      <p>Time Multiplier</p>
      <motion.input
        type="text"
        name="userName"
        animate={{ boxShadow: "10px 10px 0 rgba(0, 0, 0, 0.2)" }}
        aria-label="required"
        className="form-control mb-2 mr-sm-2 inputTexto"
        placeholder="Multiplicador"
        value={multiplicador}
        onChange={(event) => {
          setMultiplicador(event.target.value);
        }}
      />

      <p>Add Issues:</p>
      <p style={{ fontSize: "16px" }}>set each issue separated by comma</p>

      <motion.textarea
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 1 } }}
        className="form-control"
        name="issues-txtarea"
        id="issues-txtarea"
        rows="3"
        value={issues}
        style={{ width: "35%" }}
        onChange={(event) => {
          setIssues(event.target.value);
        }}
      />

      <button
        type="button"
        className="btn btn-primary mt-3"
        onClick={routeChange}
      >
        Continuar
      </button>
    </motion.div>
  );
}
